// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2N881","location":"Header_location__3pQgU"};